import React, { useEffect, useRef } from 'react'
import './Ourcolor.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Ourcolor = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);

    useEffect(() => {
        const cards = cardRefs.current;

        const initialPositions = [
            { x: 0, y: 100, opacity: 0 },
            { x: 0, y: 150, opacity: 0 },
            { x: 0, y: 200, opacity: 0 },
            { x: 0, y: 250, opacity: 0 },
            { x: 0, y: 300, opacity: 0 }
        ];

        cards.forEach((card, index) => {
            gsap.fromTo(
                card,
                initialPositions[index],
                {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: card,
                        start: "top 100%",
                        toggleActions: "play none none none",
                        //   markers: true
                    },
                }
            );

            gsap.set(card, { transformOrigin: "center" });

            card.addEventListener("mouseenter", () => {
                gsap.to(card, { scale: 1, duration: 0.3 });
            });

            card.addEventListener("mouseleave", () => {
                gsap.to(card, { scale: 1, duration: 0.3 });
            });
        });
    }, []);
    return (
        <>
            <section className='ourcolortomimainprnt'>
                <div className="custom-container" ref={sectionRef}>

                    <div className="ourcolormainchld">

                        <div className="headercolorpicker">
                            <h2>
                                2. Our Colors
                            </h2>
                            <p>tomi Storage scales seamlessly to accommodate your growing data volume.</p>
                        </div>
                        <div className="conatinercolormain">

                            <div className="pinkcolor" ref={(el) => (cardRefs.current[0] = el)}>
                                <div className="cntpink">
                                    <h5>Tomi Pink</h5>
                                    <h6>#EF0073</h6>
                                </div>
                            </div>
                            <div className="pinkcolorinnner" ref={(el) => (cardRefs.current[1] = el)}>
                                <div className="cntlightpink">
                                    <h5>Light Pink</h5>
                                    <h6>#FFBCDF</h6>
                                </div>
                            </div>
                            <div className="whitecolormain" ref={(el) => (cardRefs.current[2] = el)}>
                                <div className="cntwhite">
                                    <h5>Almost White</h5>
                                    <h6>#F5F9FF</h6>
                                </div>
                                <div className="cntlightwhite">
                                    <h5>Blue Wash</h5>
                                    <h6>#E8F2FF</h6>
                                </div>
                            </div>
                            <div className="Anthracitemain" ref={(el) => (cardRefs.current[3] = el)}>
                                <div className="Anthracitecolor">
                                    <h5>Anthracite</h5>
                                    <h6>#222D37</h6>
                                </div>
                                <div className="spacebluecolor">
                                    <h5>Space Blue</h5>
                                    <h6>#C8D7EF</h6>
                                </div>
                            </div>
                            <div className="blackcolormain" ref={(el) => (cardRefs.current[4] = el)}>
                                <div className="cntblack">
                                    <h5>Black</h5>
                                    <h6>#000000</h6>
                                </div>
                                <div className="cntblue">
                                    <h5>Teal Blue</h5>
                                    <h6>#EF0073</h6>
                                </div>
                            </div>


                        </div>


                    </div>
                </div>
            </section>
        </>
    )
}

export default Ourcolor